import {styled} from '@mui/material/styles'
import Box from '@mui/material/Box'

export const StyledTabLabelContainer = styled(Box)(({theme}) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(0.5),
  fontSize: theme.typography.subtitle1.fontSize
}))

export const StyledTabBadge = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isActive'
})(({theme, isActive}) => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  minWidth: 20,
  height: 20,
  padding: theme.spacing(0, 0.5),
  borderRadius: theme.spacing(1.25),
  fontSize: theme.typography.caption.fontSize,
  fontWeight: theme.typography.fontWeightBold,
  backgroundColor: isActive ? theme.palette.primary.main : 'transparent',
  color: isActive ? theme.palette.primary.contrastText : theme.palette.text.secondary,
  border: isActive ? 'none' : '1px solid',
  borderColor: theme.palette.divider
}))
